import { useSendExternalSignatureMail } from "@/orval/gen"
import { showErrorNotification } from "@/utils/form-submission-notifications"
import { CancelButton } from "@components/Buttons"
import { DefaultModal } from "@components/default-modal"
import { FormButtonGroup } from "@components/form-button-group"
import { Button, LoadingOverlay, ModalProps, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
export function SendMailModal({
  contractId,
  ...modalProps
}: { contractId: number } & Omit<ModalProps, "children">) {
  const { t } = useTranslation("app_server")
  const { mutateAsync: sendMail, isPending } = useSendExternalSignatureMail({
    mutation: { onSuccess: modalProps.onClose, onError: showErrorNotification },
  })
  return (
    <DefaultModal {...modalProps} title={t("ContractTracking_SendMailTitel")}>
      <LoadingOverlay visible={isPending} />
      <Stack>
        <Text style={{ whiteSpace: "pre-wrap" }}>
          {t("ContractTracking_SendMailDescription")}
        </Text>
        <FormButtonGroup>
          <CancelButton onClick={modalProps.onClose} />
          <Button onClick={async () => await sendMail({ data: contractId })}>
            {t("Send")}
          </Button>
        </FormButtonGroup>
      </Stack>
    </DefaultModal>
  )
}
